'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onSave"];
import PropTypes from 'prop-types';
import { PopoverType } from '../../constants/popover';
import AnchorPopoverBodyControls from './AnchorPopoverBodyControls';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  onSave: PropTypes.func.isRequired
};
function AnchorPopoverBodyEdit(props) {
  const {
      onSave
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", {
    className: "animated-popover-edit",
    children: /*#__PURE__*/_jsx(AnchorPopoverBodyControls, Object.assign({}, rest, {
      popoverType: PopoverType.EDIT,
      onSubmit: onSave
    }))
  });
}
AnchorPopoverBodyEdit.propTypes = propTypes;
AnchorPopoverBodyEdit.displayName = 'AnchorPopoverBodyEdit';
export default AnchorPopoverBodyEdit;